var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-button',{staticClass:"margin-left",attrs:{"size":_vm.size,"type":_vm.type},on:{"click":_vm.showDialog}},[_vm._v(_vm._s(_vm.text))]),_c('login-dialog',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }